module.exports = __webpack_public_path__ + "static/img/01.b664bf2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/raz_frauenfeld/01.jpg
// module id = 440
// module chunks = 1